export default __webpack_public_path__ + "static/rocket-f118ac50f920d4c2e7cb758c5485b596.svg";